import CompletionPage from "./CompletionPage";

export default CompletionPage;
